export const formatNumber = (num: number) => num.toLocaleString('pl-PL');
